var CreationMethod;
(function (CreationMethod) {
    CreationMethod[CreationMethod["Onboarding"] = 1] = "Onboarding";
    CreationMethod[CreationMethod["ManualCreation"] = 2] = "ManualCreation";
    CreationMethod[CreationMethod["ManualImport"] = 3] = "ManualImport";
})(CreationMethod || (CreationMethod = {}));
export {};
